import { render, staticRenderFns } from "./IchingGateList.vue?vue&type=template&id=65d04a4e&"
import script from "./IchingGateList.vue?vue&type=script&lang=js&"
export * from "./IchingGateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports